import React, { useCallback, memo } from 'react';
import { connect } from 'react-redux';
import SliderListItem from '../../../../../../list-items/SliderListItem/SliderListItem';
import { createActions } from '../../../../store';

const WaveLayerHeightListItem = memo(({ index, waveScaleFactor, updateWaveLayerCustomOptions }) => {
    const handleChange = useCallback(
        (value) => updateWaveLayerCustomOptions(index, "waveScaleFactor", value),
        [index]
    );

    return (
        <SliderListItem
            title="Wave Height"
            value={waveScaleFactor}
            displayMultiplier={100 / 4}
            onValueChange={handleChange}
            min={0}
            max={100}
            step={1}
        />
    );
});

const mapStateToProps = (state, { index }) => {
    const { waveScaleFactor } = state.createPreview.present.videoSettings.visualizer.waveCircles[index].customOptions;
    return { waveScaleFactor };
}

const mapDispatchToProps = (dispatch) => ({
    updateWaveLayerCustomOptions: (index, key, value) => dispatch(createActions.updateWaveLayerCustomOptions(index, key, value))
});

export default connect(mapStateToProps, mapDispatchToProps)(WaveLayerHeightListItem);
